import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';

@Component({
  selector: 'nbx-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom
})
export class RadioComponent implements OnInit, OnChanges{
  @Input() label = "Radio"
  @Input() status = "primary";
  @Input() disableall = false;
  @Input() optionstr: string = '';

  @Output() selected = new EventEmitter()

  options: any

  ngOnInit() {
    this.options = (this.optionstr == '') ? [
      { value: 'This is value 1', label: 'Option 1' },
      { value: 'This is value 2', label: 'Option 2', disabled: true },
      { value: 'This is value 3', label: 'Option 3' },
      { value: 'This is value 4', label: 'Option 4', disabled: true },
      { value: 'This is value 5', label: 'Option 5' },
    ] : JSON.parse(this.optionstr);
  }

  ngOnChanges() {
    this.options = (this.optionstr == '') ? [
      { value: 'This is value 1', label: 'Option 1' },
      { value: 'This is value 2', label: 'Option 2', disabled: true },
      { value: 'This is value 3', label: 'Option 3' },
      { value: 'This is value 4', label: 'Option 4', disabled: true },
      { value: 'This is value 5', label: 'Option 5' },
    ] : JSON.parse(this.optionstr);
  }
  option;

  sendValue(e) {
    this.selected.emit(e)
  }

}